export default __webpack_public_path__ + "static/media/ic-sm-cultivation-3.2dd4ac9e.svg";